import React, { useEffect, useRef } from "react";
import { Services } from "../constant/Services";
import { useLocation } from "react-router-dom";

const ServicesPage = () => {
  const servicesRef = useRef();
  const { hash } = useLocation();
  useEffect(() => {
    servicesRef.current?.scrollIntoView({
      behavior: "smooth",
    });
  }, []);
  return (
    <div className="container py-16 mx-auto flex flex-col gap-20">
      {Services.map((service, index) => (
        <div
          key={index}
          className={`${
            index & 1 ? "lg:flex-row" : "lg:flex-row-reverse"
          } flex items-center gap-10 flex-col p-5 overflow-hidden justify-center`}
          id={service.id}
          ref={
            hash.slice(1).toLowerCase().trim() ===
            service.id.toLowerCase().trim()
              ? servicesRef
              : null
          }
        >
          <div
            data-aos="flip-left"
            data-aos-easing="ease-out-cubic"
            data-aos-duration="1500"
          >
            <img
              src={service.img}
              alt={service.title}
              loading="lazy"
              className="max-h-[700px]"
            />
          </div>
          <div
            className="info flex-col flex gap-5 max-w-[800px]"
            data-aos="zoom-in-up"
            data-aos-easing="liner"
            data-aos-duration="1000"
          >
            <h2 className="font-bold text-2xl">{service.title}</h2>
            <p>{service.content}</p>
            {service.more && (
              <a
                className="text-center font-semibold hover:bg-black hover:text-white uppercase max-lg:mx-auto block rounded-full border-2 border-black w-40 py-4 mt-6 transition-all"
                href={`${service.id}`}
              >
                Read more
              </a>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ServicesPage;
